import { useState } from 'react';
import { pluralize, currency } from '../utils';
import { StyleCTA } from '../style_cta';
import { Amenity } from '../amenity';
import { stripLeadingZeros } from '../utils';

export function Card ({ unit, amenities }) {
    const [open, setOpen] = useState(false);

    // list of amenities checked but not included in this unit
    const negativeAmenities = amenities.filter(( amenity ) => {
        return !unit.amenities.find(( item ) => item == amenity );
    });
    let amenitiesSection;
    if(negativeAmenities.length > 0 || unit.amenities.length > 0) amenitiesSection = (
    <div>
        <div className="p-4 rentals-section__card__headline">
            Show More Features <a onClick={ () => { setOpen(!open) } }>+</a>
        </div>
        <div className={ open ? 'p-4 rentals-section__card__amenities--open' : 'p-4 rentals-section__card__amenities--closed' }>
            { unit.amenities.map( ( amenity, index ) => (
                <Amenity key={ index } amenity={ amenity } amenities={ amenities }></Amenity>
            ))
            }
            { negativeAmenities.map( ( amenity, index ) => (
                <Amenity key={ index } amenity={ amenity } amenities={ amenities } negative></Amenity>
            ))
            }
        </div>
    </div>
    );

    let styleType = '';
    if(unit?.project?.fields?.card_overrides?.style) {
        styleType = <div className="rentals-section__card__type">{ unit?.project?.fields?.card_overrides?.style}</div>;
    }

    const featureImage = () => {
        if(unit?.project?.fields?.image_gallery) {
            return(
                <img src={ unit?.project?.fields?.image_gallery[0] } className="rentals-section__card__image" />
            )
        } else if(unit?.project?.fields?.featured_image) {
            return (
                <img src={ unit?.project?.fields?.featured_image} className="rentals-section__card__image" />
            );
        }

        return(
            <img src='/app/themes/flipp/public/images/null-image-icon.svg' className="rentals-section__card__image" />
        )

    };

    return(
        <div className="rentals-section__card">
            <div className="rentals-section__card__image_holder">
                { featureImage() }
                { styleType }
            </div>
            <div className="rentals-section__card__info">
                <div className="rentals-section__card__building">
                    { unit.property }
                </div>
                <div className="rentals-section__card__header">
                    <div className="rentals-section__card__name"><strong>#{ stripLeadingZeros(unit.apartmentName) }</strong><br />{ unit.floorplanName }</div>
                    <div className="rentals-section__card__cost"><span className="header-3">{ currency( unit.rent ) }</span>/mo</div>
                </div>
                <div className="rentals-section__card__calendar">
                    <div className="calendar-icon"></div>
                    { unit.dateShown }
                </div>

                <div className="rentals-section__card__features">
                    <div>
                        <strong>{ unit.sqft.toLocaleString() }</strong><br />
                        SqFt
                    </div>
                    <div>
                        <strong>{ unit.beds }</strong><br />
                        Bed
                    </div>
                    <div>
                        <strong>{ unit.baths }</strong><br />
                        Bath
                    </div>
                </div>
                <div className="rentals-section__card__cta-holder">
                    <StyleCTA unit={ unit }>See Details</StyleCTA>
                </div>


            </div>
        </div>
    );
};